import {
  useQuery,
  type QueryFunctionContext,
  type UseQueryOptions,
} from "@tanstack/react-query";
import { getNgcMe, type NGCMeResponse } from "./api";

const ngcApiKeyAccessStaleTimeMs = 5 * 60 * 1000;

export const ngcApiKeyAccessKeys = {
  all: ["ngc-api-key-access"] as const,
  currentUser: (email: string) =>
    [...ngcApiKeyAccessKeys.all, "current-user", email] as const,
};

export function ngcMeQueryOptions(
  email: string,
  enabled: boolean,
): UseQueryOptions<
  NGCMeResponse,
  Error,
  NGCMeResponse,
  ReturnType<typeof ngcApiKeyAccessKeys.currentUser>
> {
  return {
    queryKey: ngcApiKeyAccessKeys.currentUser(email),
    queryFn: ({
      signal,
    }: QueryFunctionContext<
      ReturnType<typeof ngcApiKeyAccessKeys.currentUser>
    >) => getNgcMe(signal),
    enabled: enabled && Boolean(email),
    staleTime: ngcApiKeyAccessStaleTimeMs,
    retry: false,
  };
}

export function useNgcMeQuery(email: string, enabled: boolean) {
  return useQuery(ngcMeQueryOptions(email, enabled));
}
